'use strict';

var exitListItem = require('./exitListItem');

/**
 * User pressed Delete in an editor
 */
function onBackspace(event, data, state, opts) {
    var startOffset = state.startOffset;


    if (startOffset > 0) {
        return;
    }

    event.preventDefault();
    return exitListItem(state, opts);
}

module.exports = onBackspace;


//////////////////
// WEBPACK FOOTER
// ./~/slate-edit-list/dist/onBackspace.js
// module id = 675
// module chunks = 0